import {Navigate} from "react-router-dom";
import Login from "../../pages/authentication/Login";

export const authenticationRoutes = [
    {
        name: "Authentication",
        route: '/login',
        component: <Login />,
    },
    {
        name: "Authentication",
        route: `/*`,
        component: <Navigate to='login' />,
    }
];

